module.exports = __webpack_public_path__ + "img/bulletedList_w.c16366b3.svg";